angular.module('impactx.company').controller('CompanyRelationCtrl', [
    '$scope',
    'dataGen',
    'TranslationService',
    'ToastService',
    '$routeParams',
    'ControlRelationService',
    'BackService',
    'ToolbarService',
    'PartialDialogsService',
    CompanyRelationCtrl
]);

function CompanyRelationCtrl($scope, dataGen, TranslationService, ToastService, $routeParams, ControlRelationService,
                             BackService, ToolbarService, PartialDialogsService) {
    var self = this;
    $scope.label_save = TranslationService.get('save');

    var companyId = $routeParams.id;
    dataGen.getData($scope, {id: companyId}, "/company/companyrelation/view").then(function (data) {
        $scope.trns.save = TranslationService.get('save');
        $scope.trns.required = TranslationService.get('required');
        $scope.trns.noSelectedItemMessage = TranslationService.get('noSelectedItemMessage');

        if (data.data.companyControls) {
            prepareControlRelations(data.data.companyControls);
        }
        defineButtons();
    });

    self.savePageData = function ($event) {
        prepareControlRelationsForSave();

        return dataGen.postAsForm($scope, {companyRelation: $scope.data}, "/company/companyrelation/save").then(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            PartialDialogsService.showDialog($event, PartialDialogsService.TYPE.COMPANY, companyId, 'companyrelation');
        });
    };

    function prepareControlRelations(relations) {
        $scope.controlSettings = [];
        angular.forEach(relations, function (relation) {
            $scope.controlSettings.push({});
            ControlRelationService.setControlDataToScope($scope.controlSettings[$scope.controlSettings.length - 1], relation.companyControlRelation);

            angular.merge($scope.controlSettings[$scope.controlSettings.length - 1], relation);
        });
    }

    function prepareControlRelationsForSave() {
        for (var i = 0; i < $scope.controlSettings.length; i++) {
            $scope.data.companyControls[i] = {companyControlRelation: {}};
            ControlRelationService.copyRelationDataToDTO($scope.data.companyControls[i].companyControlRelation, $scope.controlSettings[i]);
            delete $scope.controlSettings[i].readOnlyRelation;
            delete $scope.controlSettings[i].assignedRelation;
            delete $scope.controlSettings[i].deniedRelation;
            delete $scope.controlSettings[i].companyControlRelation;
            angular.extend($scope.data.companyControls[i], $scope.controlSettings[i])
        }
    }

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.savePageData,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }
}